export const getHighResGemImage = (imageUrl: string): string => {
  // require both strings
  if (!imageUrl?.includes('/gemz-previews/') || !imageUrl?.includes('gemz_low_')) {
    return imageUrl;
  }

  return imageUrl.replace('/gemz-previews/', '/gemz/').replace('gemz_low_', 'gemz_high_');
};
